import { render, staticRenderFns } from "./newPublish.vue?vue&type=template&id=048dd4e6&scoped=true&"
import script from "./newPublish.vue?vue&type=script&lang=js&"
export * from "./newPublish.vue?vue&type=script&lang=js&"
import style0 from "./newPublish.vue?vue&type=style&index=0&id=048dd4e6&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "048dd4e6",
  null
  
)

export default component.exports